<template>
    <div class="flex justify-between px-4 py-3 my-4 text-white rounded-lg " :class="bgClass">
        <div>Get a free gift from</div>
        <router-link to="/">
          <img src="@/assets/logo.svg" alt="selena logos"  />
        </router-link>
      </div>
</template>
<script setup>
import { computed } from "vue";
const props  = defineProps({
  bgClass: {
    type: String,
    default: 'bg-brand-blue'
  }
})

</script>